// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import ReactStars from 'react-rating-stars-component';
/* eslint-disable react/jsx-boolean-value */

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivityAvgRating = ({ activity }) => {
  if (!activity) return null;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  const { ratingsCount, reviewsCount, avgRating } = activity;

  return (
    <div className='avr-rating-section'>
      <div className='avr-rating-block avr-rating-stars-block'>
        <span className='avr-rating-stars-label'>
          Avg Rating: {avgRating || 0}
        </span>
        <ReactStars
          size={17}
          value={avgRating || 0}
          edit={false}
          isHalf={true}
        />
      </div>
      <div className='avr-rating-block'># of Ratings: {ratingsCount || 0}</div>
      <div className='avr-rating-block'># of Reviews: {reviewsCount || 0}</div>
    </div>
  );
};

export default React.memo(ActivityAvgRating);
